
export const name = "page-editor-ui";
export const version = "dev";
